import React from 'react';
import Search from 'gatsby-core-theme/src/components/organisms/search';

export default function index(props) {
  return (
    <Search {...props} searchIcon={'/images/search-dark.svg'} />
  )
}
